var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisibilityFilled = function SvgVisibilityFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M10.384 10.384a2.286 2.286 0 1 1 3.232 3.232 2.286 2.286 0 0 1-3.232-3.232Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M12 4.25c-1.963 0-3.868.849-5.5 2.11-1.637 1.265-3.05 2.982-4.042 4.816a1.738 1.738 0 0 0 0 1.648c.992 1.834 2.404 3.55 4.041 4.815C8.132 18.901 10.037 19.75 12 19.75c1.963 0 3.868-.849 5.5-2.11 1.637-1.265 3.05-2.982 4.042-4.816a1.738 1.738 0 0 0 0-1.648c-.992-1.834-2.405-3.55-4.041-4.815C15.868 5.099 13.963 4.25 12 4.25Zm2.626 5.124a3.714 3.714 0 1 0-5.252 5.252 3.714 3.714 0 0 0 5.252-5.252Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisibilityFilled);
export default ForwardRef;